import styled from '@emotion/styled';

export const StyledBackButtonContainer = styled.div`
    display: flex;
    justify-content: left;
    padding: 8px 21px;
    background-color: ${(props) => props.theme.colorsUnifications.white[100]};
`;
